export const updateStats = (stat, count = 1) => {
  return fetch(`mvc/stats/actions/update${EXT}`, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: `stat=${stat}&count=${count}`,
  });
};

export const appPageTransition = (
  currentPage,
  nextPage,
  from = { out: "left", in: "right" }
) => {
  $(`#${currentPage}`)
    .attr("class", `os-animation animated fadeout${from.out}`)
    .attr("data-os-animation", `fadeout${from.out}`);

  setTimeout(() => {
    $(`#${currentPage}`).addClass("d-none");

    $(`#${nextPage}`)
      .attr("class", `os-animation animated fadein${from.in}`)
      .attr("data-os-animation", `fadein${from.in}`);
  }, 400);
};
